import {createContext} from "react";

export const GenericAppContext = createContext({});
